// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-card {
  margin: 20px 10px;
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card .wrapper {
  width: 100%;
}
ion-card ion-card-header {
  padding: 0;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title .map-icon {
  font-size: 40px;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
  word-break: break-word;
}
ion-card ion-card-header ion-card-subtitle {
  display: flex;
  font-size: 11px;
  align-items: center;
  margin-block: 5px 15px;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card ion-card-content {
  padding: 0px 8px 8px 0;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 12px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card ion-item-options ion-item-option div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}
ion-card ion-item-options ion-item-option div ion-icon {
  font-size: 30px;
}

ion-popover.map-preview {
  --width: 300px;
  --min-height: 200px;
}

ion-popover.linked-resources {
  --max-height:250px;
  overflow-x: auto;
}
ion-popover.linked-resources ion-list {
  padding: 2px 5px;
}
ion-popover.linked-resources ion-list .linked-place-container {
  padding: 1px 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}
ion-popover.linked-resources ion-list .linked-place-container .displayName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-popover.linked-resources ion-list .availibility-shape {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 3px;
}
ion-popover.linked-resources ion-list .place-type-icon {
  font-size: 20px;
  margin: 5px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-favorite-maps/add-favorite-maps.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEE;EAIE,iBAAA;AAFJ;AADI;EACE,sBAAA;AAGN;AAAI;EACE,WAAA;AAEN;AAAI;EACE,UAAA;AAEN;AADM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAGR;AAFQ;EACE,eAAA;AAIV;AAFQ;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAIV;AAAM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAER;AADQ;EACE,mBAAA;AAGV;AACI;EACE,sBAAA;AACN;AAAM;EACE,oBAAA;EACA,eAAA;AAER;AADQ;EACE,mBAAA;AAGV;AAGU;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AADd;AAEc;EACI,eAAA;AAAlB;;AAQE;EACE,cAAA;EACA,mBAAA;AALJ;;AAQE;EACE,kBAAA;EACA,gBAAA;AALJ;AAMI;EACE,gBAAA;AAJN;AAKM;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAHR;AAIQ;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAFV;AAKM;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAHR;AAKM;EACE,eAAA;EACA,mBAAA;AAHR","sourcesContent":[".spinner-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.065);\n    z-index: 999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  ion-card {\n    &:first-child {\n      margin: 10px 10px 20px;\n    }\n    margin: 20px 10px;\n    .wrapper {\n      width: 100%;\n    }\n    ion-card-header{\n      padding: 0;\n      ion-card-title {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding-inline-start: 10px;\n        justify-content: center;\n        .map-icon {\n          font-size: 40px;\n        }\n        ion-label {\n          font-size: 20px;\n          flex-grow: 3;\n          margin-bottom: 5px;\n          word-break: break-word;\n  \n        }\n      }\n      ion-card-subtitle{\n        display: flex;\n        font-size: 11px;\n        align-items: center;\n        margin-block: 5px 15px;\n        .location-icon {\n          margin-right: 2.5px;\n      }\n      }\n    }\n    ion-card-content{\n      padding: 0px 8px 8px 0;\n      ion-chip {\n        padding-inline:10px;\n        font-size: 12px;\n        ion-icon {\n          margin-right: 3.5px;\n        }\n      }\n    }\n    ion-item-options{\n      ion-item-option {\n          div {\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              gap: 5px;\n              font-size: 14px;\n              ion-icon {\n                  font-size: 30px;\n              }\n          }\n      }\n    }\n  }\n  \n  \n  ion-popover.map-preview {\n    --width: 300px;\n    --min-height: 200px;\n  }\n  \n  ion-popover.linked-resources {\n    --max-height:250px;\n    overflow-x: auto;\n    ion-list{\n      padding:2px 5px;\n      .linked-place-container {\n        padding: 1px 5px;\n        font-size: 14px;\n        display: flex; \n        align-items: center;\n        gap: 5px;\n        .displayName {\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 2;     \n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n      .availibility-shape {\n        height: 8px;\n        width: 8px;\n        border-radius: 50%;\n        margin-right: 3px;\n      }\n      .place-type-icon {\n        font-size: 20px;\n        margin: 5px 5px 0 0;\n      }\n      \n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
